import { ReactNode, useMemo } from 'react'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import KeyValueTable from '@/shared/Tables/KeyValueTable'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'

interface IProps {
  rating: Record<string, number>
  cardTitle: string | ReactNode
  loading?: boolean
}

const LiftAnalyticsRatingTableCard = (props: IProps) => {
  const tableFields = useMemo(() => {
    return Object.entries(props.rating)
      .map((v) => ({ title: v[0], value: v[1], key: v[0] }))
      .filter((v) => Boolean(v.value))
      .sort((a, b) => b.value - a.value)
  }, [props.rating])

  const renderContent = () => {
    if (tableFields.length) {
      return <KeyValueTable values={tableFields} itemStyle={{ gridTemplateColumns: '2fr 1fr' }} />
    } else {
      return (
        <div style={{ display: 'flex', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
          <EmptyPlaceholder inscription="Данные отсутствуют" />
        </div>
      )
    }
  }

  return (
    <TextStatisticCard
      title={props.cardTitle}
      width="100%"
      height="360px"
      loading={props.loading}
      style={{ height: 'fit-content', minHeight: '86px' }}
    >
      <div
        style={{
          minHeight: 0,
          height: '300px',
          overflow: 'auto',
          marginTop: '8px',
        }}
      >
        {renderContent()}
      </div>
    </TextStatisticCard>
  )
}

export default LiftAnalyticsRatingTableCard
